import type { GameState } from '../types';

/**
 * Scale play/bid utility by match marks context so risk changes with score.
 * Returns a multiplier applied to team-point evaluations.
 */
export function matchEquityMultiplier(
  state: GameState,
  myTeam: number,
  enabled: boolean,
): number {
  if (!enabled) return 1;

  const myMarks = state.teamMarks[myTeam as 0 | 1];
  const oppMarks = state.teamMarks[(1 - myTeam) as 0 | 1];
  const diff = myMarks - oppMarks;

  if (diff <= -2) return 1.08;
  if (diff >= 4) return 0.92;
  if (diff >= 2) return 0.97;
  if (diff <= -1) return 1.04;
  return 1;
}

/**
 * Adjust bidding threshold (make-rate) based on match marks.
 * Negative delta requires higher make rate; positive allows slightly lower.
 */
export function matchEquityBidThresholdDelta(
  state: GameState,
  myTeam: number,
  enabled: boolean,
): number {
  if (!enabled) return 0;

  const myMarks = state.teamMarks[myTeam as 0 | 1];
  const oppMarks = state.teamMarks[(1 - myTeam) as 0 | 1];
  const diff = myMarks - oppMarks;

  if (diff <= -2) return -0.04;
  if (diff >= 4) return 0.05;
  if (diff >= 2) return 0.03;
  if (diff <= -1) return -0.02;
  return 0;
}
